import { observer } from "mobx-react-lite";
import useNavigateToDeal from "../../hooks/useNavigateToDeal";
import useOpenSelectedItem from "../../hooks/useOpenSelectedItem";
import DealIcon from "../icons/DealIcon";
import styles from "../InfoWithIconAndNavigation.module.css";
import DealInfo, { IDealInfoProps } from "./DealInfo";

function DealInfoWithIconAndNavigation({ id, name, value, status, stageId, buildingSize, landSizeAcres, zoning, className, onClick, index }: IDealInfoWithIconAndNavigationProps) {
    const navigateToDeal = useNavigateToDeal();

    const click = () => {
        onClick && onClick();
        navigateToDeal(id);
    };

    useOpenSelectedItem(index, click);

    return (
        <div className={[styles.container, className].join(" ")} onClick={click}>
            <DealIcon color={"#25479A"} className={styles.icon} />
            <DealInfo
                name={name}
                value={value}
                status={status}
                stageId={stageId}
                buildingSize={buildingSize}
                landSizeAcres={landSizeAcres}
                zoning={zoning}
            />
        </div>
    );
}

interface IDealInfoWithIconAndNavigationProps extends IDealInfoProps {
    id: number;
    index?: number;
}

export default observer(DealInfoWithIconAndNavigation);